import { invalidateAccountScopedData } from '~/utils/dataInvalidation';

/**
 * Clears and refetches all account-scoped data when the active child account
 * changes. `changeUser` (layers/auth) re-authenticates in place without a page
 * reload, so without this the app keeps serving the previous account's cached
 * data (the jobs grid being the obvious symptom). Client-only: every cache it
 * touches is client-fetched and a swap only ever happens through user
 * interaction.
 */
export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.hook('app:account-switched', () => invalidateAccountScopedData());
});
